<template>
    <div id="nursingStar" class="flex align-items-center justify-content-center">
        <img :src="commonStore.getImgUrl('shared', 'starIconPurple', 'svg')" class="mb-12" style="width: 2vw; margin-left: 20%;"/>
        <p class="font-jost mt-2 text-2xl" style="margin-left: 1.5%;"><b>{{ text }}</b></p>
    </div>
</template>
  
<script setup lang="ts">
  import { computed, onMounted, ref } from "vue";
  import { useCommonStore } from "@/stores/common";
  import { useI18n } from "vue-i18n";
  
  const commonStore = useCommonStore();
  const { t, locale } = useI18n();
  
  onMounted(async () => {}); 
  
  import { toRefs } from "vue";
  
  const props = defineProps({
    starIconObj: {
      type: Object,
      default: {},
      //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg' }
    },
    text: {
        type: String,
        default: "TEST"
    }
  });
  //const { label } = toRefs(props);
</script>
  
<style>
</style>